import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "immutability"
    }}>{`Immutability`}</h1>
    <p>{`Chonky assumes that the objects and arrays you provide through `}<inlineCode parentName="p">{`FileBrowser`}</inlineCode>{` props (or
any other props) are `}<strong parentName="p">{`immutable`}</strong>{`. It is very important for your application to
guarantee immutability, otherwise Chonky components will not update correctly.`}</p>
    <h2 {...{
      "id": "what-is-immutability"
    }}>{`What is immutability?`}</h2>
    <p>{`Immutability is a crucial concept in React performance optimizations, and is used in
many React libraries, such as Redux. If you're new to React, you should learn this
concept as soon as possible.`}</p>
    <p>{`I will not go into the details of data immutability here. Instead, I'll point you to
some useful resources which you can study yourself:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://daveceddia.com/react-redux-immutability-guide/"
        }}>{`Dave Ceddia - Immutability in React and Redux: The Complete Guide`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://redux.js.org/faq/immutable-data"
        }}>{`Redux FAQ - Immutable Data`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://stackoverflow.com/questions/34958775/why-should-objects-in-redux-be-immutable/34962065#34962065"
        }}>{`StackOverflow - Why should objects in Redux be immutable?`}</a></li>
    </ul>
    <h2 {...{
      "id": "example-of-a-common-mistake"
    }}>{`Example of a common mistake`}</h2>
    <p>{`Consider this example - you want to add a new file to the `}<inlineCode parentName="p">{`files`}</inlineCode>{` array. The intuitive
way is to just `}<inlineCode parentName="p">{`.push()`}</inlineCode>{` the new file. However, this will change the
array contents without updating array reference, which violates the principle of
immutability.`}</p>
    <p>{`The correct approach would be to create a new array (and thus obtain a
new array reference), then copy over all elements from the old array, appending the
new file to the end of the array.`}</p>
    <p>{`Here's the code illustrating the above example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`// Incorrect - mutating the array:
const oldArray1 = [1];
const newArray1 = oldArray1;
newArray1.push(2);
console.log(oldArray1 === newArray1); // prints \`true\`, React can't tell the difference

// Correct - creating new array:
const oldArray2 = [1];
const newArray2 = [...oldArray2, 2];
console.log(oldArray2 === newArray2); // prints \`false\`, React knows array changed
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      